/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Importing_TracksInputs */

const en_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing tracks...`)
};

const fr_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des pistes...`)
};

const de_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel werden importiert...`)
};

const it_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione delle tracce...`)
};

const ru_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт треков...`)
};

const es_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando pistas...`)
};

const zh_cn2_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入曲目……`)
};

const ja_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラックをインポートしています...`)
};

const hi_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक आयात किए जा रहे हैं...`)
};

const pt_pt2_work_order_import_status_importing_tracks = /** @type {(inputs: Work_Order_Import_Status_Importing_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando faixas...`)
};

/**
* | output |
* | --- |
* | "Importing tracks..." |
*
* @param {Work_Order_Import_Status_Importing_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_importing_tracks = /** @type {((inputs?: Work_Order_Import_Status_Importing_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Importing_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_status_importing_tracks(inputs)
	if (locale === "de") return de_work_order_import_status_importing_tracks(inputs)
	if (locale === "it") return it_work_order_import_status_importing_tracks(inputs)
	if (locale === "ru") return ru_work_order_import_status_importing_tracks(inputs)
	if (locale === "es") return es_work_order_import_status_importing_tracks(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_status_importing_tracks(inputs)
	if (locale === "ja") return ja_work_order_import_status_importing_tracks(inputs)
	if (locale === "hi") return hi_work_order_import_status_importing_tracks(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_status_importing_tracks(inputs)
	return en_work_order_import_status_importing_tracks(inputs)
});